/*
 * Authors: mariushirjanu, Koen
 * Created: 02/11/2015
 * Upgraded: 23/06/2023
 */

import { IContact } from '../../../../../type_definitions/datatypes';
import { IRequesterAddress } from '../order-entry-data.service';
import { Injectable } from '@angular/core';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { EVENT_ORDER_REQUESTER_CONTACT_CHANGED } from '../../../../shared/app-events';

@Injectable()
export class OrderEntryRequesterService {
  private _contact:IContact;
  private _address:IRequesterAddress;

  constructor(
    private eventService:GaEventService
  ) {
    /***/
  }

  public get contact():IContact {
    return this._contact;
  }

  public set contact(contact:IContact) {
    this._contact = contact;
    this.eventService.sendMessage(EVENT_ORDER_REQUESTER_CONTACT_CHANGED, contact);
  }

  public get address():IRequesterAddress {
    return this._address;
  }

  public set address(address:IRequesterAddress) {
    this._address = address;
  }

  public clear():void {
    this._contact = undefined;
    this._address = undefined;
  }
}